import React from 'react';
import { Link } from 'react-router-dom';
import { FiHexagon } from 'react-icons/fi';
import './Navbar.css';

const Navbar: React.FC = () => {
  return (
    <nav className="navbar-container">
      <div className="navbar-logo">
        <FiHexagon size={24} />
        <span>JMK Studio</span>
      </div>
      <div className="navbar-links">
        <Link to="/">Inicio</Link>
        <a href="/#nosotros">Nosotros</a>
        <Link to="/servicios">Servicios</Link>
        {/* --- 👇 CAMBIO AQUÍ 👇 --- */}
        <Link to="/equipo">Equipo</Link> 
        <a href="/#contacto">Contacto</a>
      </div>
    </nav>
  );
};

export default Navbar;
